import axios from 'axios'; // used for interacting with the backend API
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../Mantle Logo.png';

// Public backend URL, pulled from runtime config (public/config.js) so it can
// be set per deployment without rebuilding. Falls back to localhost for dev.
// The `typeof window` guard is for the build-time prerender (scripts/prerender.js),
// which evaluates this module in Node where there is no window.
const API_URL =
  (typeof window !== 'undefined' && window.MANTLE_CONFIG?.API_URL) ?? 'http://localhost:5000/api';

// URL-safe base64 of a UTF-8 string, using browser-native APIs.
// Produces the same output the backend expects from the previous
// Buffer.from(str, 'utf8').toString('base64') + char swap (padding kept),
// without pulling in the Node 'buffer' polyfill webpack 5 no longer ships.
const toBase64Url = (input) => {
  const bytes = new TextEncoder().encode(input);
  let binary = '';
  bytes.forEach((b) => { binary += String.fromCharCode(b); });
  return btoa(binary).replaceAll('+', '-').replaceAll('/', '_');
};

const Domain = () => {
  const [domain, setDomain] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  
  const checkDomain = (e) => {
    e.preventDefault(); // Prevents the page from refreshing
    
    let _domain = document.getElementById("domain").value;
    // let cont = document.getElementById("continue");
    
    /* Ask the server to check for a tenant with the given tennant (domain) name, returning true/false match */
    axios.get (API_URL + '/users/check-domain/' + _domain).then(response => {
      // Handle the retrieved data
      if (response.data?.matches && response.data?.url?.length > 0) {
        const B64URL = toBase64Url(response.data?.db_name);
        setError ('');
        setSuccess ('Matching domain found. Please wait to be redirected ...');
        
        window.location.href = response.data.url + "/login?d=" + B64URL;
      } else {
        setSuccess ('');
        setError('Domain Not Found! Please type in a valid domain.');
      }
    }).catch(error => {
      // Handle any errors
      let msg = "An error occured while checking the domain: " + error.message;
      
      console.error (msg);
      setError (error.message);
    });
  };

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      backgroundColor: '#fafafa',
      fontFamily: 'Segoe UI, Roboto, Helvetica, Arial, sans-serif'
    }}>
      <div style={{
        width: '100%',
        maxWidth: '400px',
        backgroundColor: 'white',
        padding: '40px',
        borderRadius: '8px',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
        border: '1px solid #e5e5e5'
      }}>
        {/* Branding */}
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
            <img 
                src={logo}
                alt="Mantle Logo"
                style={{ height: '32px', width: 'auto' }} 
            />

          <p style={{ margin: '5px 0 0 0', color: '#737373', fontSize: '0.9rem' }}>
            Please enter your company's domain name.
          </p>

        </div>

        <form onSubmit={checkDomain} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          
          {/* Domain */}
          <div id="domain-wrapper" style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <label htmlFor="domain" style={{ fontSize: '0.85rem', fontWeight: '600', color: '#525252' }}>Domain Name:</label>
            <input 
              type="text" 
              value={domain}
              onChange={(e) => setDomain(e.target.value)}
              name="domain"
              id="domain"
              style={{
                padding: '10px 12px',
                borderRadius: '4px',
                border: '1px solid #d4d4d4',
                fontSize: '1rem',
                outline: 'none'
              }}
              placeholder="Eg: Mantle_Budget"
            />
          </div>

          {/* Error Message */}
          {error && (
            <div id="error-wrapper" style={{ color: '#b00020', fontSize: '0.85rem', textAlign: 'center' }}>
              {error}
            </div>
          )}
          
          {/* Success Message */}
          {success && (
            <div id="success-wrapper" style={{ color: '#0a7d32', fontSize: '0.85rem', textAlign: 'center' }}>
              {success}
            </div>
          )}
          
          {/* Check Button */}
          <button 
            type="submit"
            style={{
              marginTop: '10px',
              padding: '12px',
              backgroundColor: '#0a0a0a',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              fontSize: '1rem',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'background-color 0.2s'
            }}
            onMouseOver={(e) => e.target.style.backgroundColor = '#171717'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#0a0a0a'}
            onClick={(e) => checkDomain(e)}
          >
            Check Domain
          </button>
        </form>

        {/* Back to the public marketing site */}
        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          <Link to="/" style={{ color: '#737373', fontSize: '0.85rem', textDecoration: 'none' }}>
            &larr; Back to mantlebudget.com
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Domain;
